import React, { useState, forwardRef } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from './input';

/**
 * Passwort-Feld mit Auge-Toggle zum Ein-/Ausblenden.
 * Drop-in-Ersatz für <Input type="password" ...> — reicht alle Props
 * an das innere Input durch (value, onChange, id, placeholder, required,
 * data-testid, ...). Der Toggle ist tabIndex={-1}, damit er den
 * Tastatur-Fokusfluss (Passwort -> Submit) nicht unterbricht.
 */
const PasswordInput = forwardRef(({ className = '', ...props }, ref) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        ref={ref}
        type={show ? 'text' : 'password'}
        className={`pr-10 ${className}`}
        {...props}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? 'Passwort verbergen' : 'Passwort anzeigen'}
        className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300"
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
